import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsCustomIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-custom-time-scale-issue',
	path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId/:issueKey',
	exact: true,
};
